import type {
  EmailMessagePlaceholder,
  LocaleMessages,
  Locales,
  ServerConfig
} from 'shared-types';

interface Params {
  language: Locales;
  messages: LocaleMessages;
  serverConfig: Pick<
    ServerConfig,
    'adminUrl' | 'emailDefaultReplyTo' | 'serverName' | 'serverNameTranslations'
  >;
}

const getDefaultPlaceholders = ({
  language,
  messages,
  serverConfig
}: Params): { [key: string]: EmailMessagePlaceholder } => ({
  contactEmail: {
    label: messages.emailContactEmailAddress,
    value: serverConfig.emailDefaultReplyTo || 'help@vuolearning.fi'
  },
  resetPasswordUrl: {
    label: messages.emailResetPasswordLink,
    value: `${serverConfig.adminUrl}/reset-password`
  },
  siteName: {
    label: messages.siteSettingsServerName,
    value:
      serverConfig.serverNameTranslations?.[language] || serverConfig.serverName
  },
  siteUrl: {
    label: messages.commonSiteLink,
    value: serverConfig.adminUrl
  }
});

export default getDefaultPlaceholders;
